import RADApplication from '@/Management/RADApplication';

export function getLanguageFullName(name: string): string {
    let languages = RADApplication.getInstance().configuration.languages;

    for (let language of languages) {
        if (language.iso6391.toLowerCase() === name.toLowerCase()){
            return language.displayName;
        }
    }

    return name;
}

export default {getLanguageFullName}